/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  SET_LIST(state, data) {
    state.list = data.items;
    if (data && data.pagination) {
      state.pagination = { ...state.pagination, ...data.pagination };
    }
  },
  SET_DETAIL(state, data) {
    state.selecting = data;
  },
  UPDATE_SUCCESS(state, data) {
    const pos = state.list
      .map(function (e) {
        return e.id;
      })
      .indexOf(data.id);
    state.list.splice(pos, 1, data);
  },
  CREATE_SUCCESS(state, data) {
    state.list.unshift(data);
  },
};
